module.exports = __webpack_public_path__ + "img/headerBgM.4a2a9816.webp";